<template>
    <!-- 配置标签 -->
    <Modal v-model="configTagModal" title="配置标签" @on-ok="configTagSubmit('configTagForm')" @on-cancel="configTagReset('configTagForm')" :loading="loading" width="50%" :mask-closable="false">
        <Form ref="configTagForm" :model="configTagForm">
            <Row :gutter="16">
                <Col span="24">
                    <FormItem label="" :label-width="100">
                        <Row style="font-size:13px;">
                            <Col span="10"><label>标签键</label></Col>
                            <Col span="10"><label>标签值</label></Col>
                        </Row>
                        <div v-for="(item,index) in configTagForm.reservedInstanceTagList" :key="index">
                            <Row :gutter="4" style="margin-bottom:20px;">
                                <Col span="10">
                                    <FormItem label="" :prop="'reservedInstanceTagList.' + index + '.standardKeyId'" :rules="{required: true, message: '请选择标签键', trigger: 'change', type: 'number'}">
                                        <Select v-model="item.standardKeyId" filterable :transfer="true" placeholder="">
                                            <Option :value="item.id" v-for="item in reservedInstanceTagKeyList" :key="item.id">{{item.keyName}}</Option>
                                        </Select>
                                    </FormItem>
                                </Col>
                                <Col span="10">
                                    <FormItem label="" :prop="'reservedInstanceTagList.' + index + '.tagValue'" :rules="[{required: true, message: '请输入标签值', trigger: 'blur'},{pattern:/^([\u4e00-\u9fa5a-zA-Z0-9]|[\u4e00-\u9fa5a-zA-Z0-9].*[\u4e00-\u9fa5a-zA-Z0-9])$/, message:'标签值前后不能有特殊字符和空格', trigger:'blur'}]">
                                        <Input type="text" v-model="item.tagValue"></Input>
                                    </FormItem>
                                </Col>
                                <Col span="4">
                                    <Button @click="handleRemoveTag(index)">删除</Button>
                                </Col>
                            </Row>
                        </div>
                        <Row>
                            <Col span="20">
                                <Button type="dashed" long @click="handleAddTag()" icon="md-add" style="width:100%">添加标签</Button>
                            </Col>
                        </Row>
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </Modal>
</template>
<script>
    import {getCookie} from "../../../../../utils/cookieUtil";
    let configurationReservedInstanceTag = {};
    export default {
        name: 'ConfigurationReservedInstanceTag',
        data() {
            return {
                row: '',
                type: 0, // 类型  0:EC2  1:RDS  2:ElasticCache 3:Redshift 4:Elasticsearch
                configTagModal: false,
                loading: true,
                configTagForm: {
                    reservedInstanceTagList: [{
                        standardKeyId: '',
                        tagValue: ''
                    }]
                },
                reservedInstanceTagKeyList: []
            }
        },
        beforeCreate: function () {
            configurationReservedInstanceTag = this
        },
        methods: {
            // 点击配置标签
            getConfigurationReservedInstanceTagList: function (row,type) {
                this.configTagModal = true;
                // 当前行
                this.row = row;
                // 预留实例类型
                this.type = type;
                var reservedInstanceRequestDTO = {
                    "reservedInstanceId":this.row.reservedInstanceId,
                    "type":this.row.type
                }

                //查询标签键
                this.$api.tag.getStandardTagListByCompanyId("companyId",this.$parent.reservedInstanceDTO.companyId)
                .then(res => {
                    if (res.data != null && res.data != undefined) {
                        this.reservedInstanceTagKeyList = res.data;
                    }
                });

                //查询已有标签
                this.$api.reservedInstanceTagRelationship.queryTagList(reservedInstanceRequestDTO)
                .then(res => {
                    if (res.data != null && res.data != undefined) {
                        if (res.data != null && res.data != undefined && res.data.length > 0) {
                            this.configTagForm.reservedInstanceTagList = res.data;
                        }
                    }
                });
            },
            // 删除标签
            handleRemoveTag(index) {
                this.configTagForm.reservedInstanceTagList.splice(index, 1)
            },
            //添加标签
            handleAddTag() {
                this.configTagForm.reservedInstanceTagList.push({
                    standardKeyId: '',
                    tagValue: ''
                })
            },
            // 提交
            configTagSubmit: function (name) {
                this.$refs[name].validate(valid => {
                    if(valid){
                        var reservedInstanceRequestDTO = {
                            "reservedInstanceId":this.row.reservedInstanceId,
                            "type":this.row.type,
                            "tagRelationships": this.configTagForm.reservedInstanceTagList
                        }
                        //查询已有标签
                        this.$api.reservedInstanceTagRelationship.addRelationship(reservedInstanceRequestDTO)
                        .then(res => {
                            setTimeout(() => {
                                switch (this.type) {
                                    case 0:
                                        // EC2
                                        this.$parent.getReservedInstances(this.$parent.reservedInstanceDTO);
                                        break;
                                    case 1:
                                        // RDS
                                        this.$parent.getReservedInstances(this.$parent.reservedInstanceDTO);
                                        break;
                                    case 2:
                                        // ElasticCache
                                        this.$parent.getReservedInstances(this.$parent.reservedInstanceDTO);
                                        break;
                                    case 3:
                                        // Redshift
                                        this.$parent.getReservedInstances(this.$parent.reservedInstanceDTO);
                                        break;
                                    case 4:
                                        // Elasticsearch
                                        this.$parent.getReservedInstances(this.$parent.reservedInstanceDTO);
                                        break;
                                    default:
                                        break;
                                }
                                this.$refs[name].resetFields();
                                this.loading = false;
                                this.$nextTick(() => {
                                    this.loading = true;
                                });
                                this.$Message.success('提交成功');
                                this.configTagModal=false;
                            }, 1000);
                        });
                    }else{
                        this.loading = false;
                        setTimeout(() => {
                            this.loading = true
                        }, 0)
                        this.$Message.error('提交失败');
                    }
                });
            },
            // 取消
            configTagReset: function (name) {
                this.configTagModal=false;
                this.$refs[name].resetFields();
                this.configTagForm.reservedInstanceTagList = [{
                    standardKeyId: '',
                    tagValue: ''
                }];
            }
        }
    }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/reserved_instance/ConfigurationReservedInstanceTag.vue